import { useCallback, useEffect, useMemo, useRef, useState } from "react";

import { observer } from "mobx-react-lite";

import iAddPeople from "../../../assets/images/100-add-people.svg";
import { useAuth } from "../../../contexts/authContext";
import { useJanusContext } from "../../../contexts/janus/JanusContext";
import { useMeetingDetailsStore } from "../../../contexts/meetingDetails/meetingDetailsContext";
import { Audio } from "../../audio-element";

import ParticipantCamera from "./participant-camera";

const CurrentMeetingUsersStatusBar = ({ count = 3 }) => {
  const { streamTracks, inRoomParticipants } = useJanusContext();
  const { participants } = useMeetingDetailsStore();
  const { userData } = useAuth();

  const [videoHeight, setVideoHeight] = useState(0);

  const restParticipants = useMemo(
    () => participants.filter((participant) => participant.user.email !== userData.email),
    [participants, userData.email],
  );

  const otherParticipantsData = useMemo(() => {
    const inRoomMap = new Map(inRoomParticipants.map((participant) => [participant.display, participant]));
    return restParticipants.map((participant) => ({
      ...participant,
      videoRoomData: inRoomMap.get(participant.user.email) || {},
    }));
  }, [restParticipants, inRoomParticipants]);

  useEffect(() => {
    if (streamTracks.combinedVideo && videoRef.current) {
      const videoElement = videoRef.current;
      const onLoadedMetadata = () => {
        setVideoHeight(videoElement.offsetHeight / 4);
      };
      videoElement.addEventListener("loadedmetadata", onLoadedMetadata);
      return () => {
        videoElement.removeEventListener("loadedmetadata", onLoadedMetadata);
      };
    }
  }, [streamTracks.combinedVideo]);

  const videoRef = useRef(null);
  const vStream = useMemo(() => (streamTracks.combinedVideo ? new MediaStream([streamTracks.combinedVideo]) : null), [streamTracks.combinedVideo]);

  const renderAudio = useCallback(() => {
    if (!streamTracks.combinedAudio) return null;
    const audioStream = new MediaStream([streamTracks.combinedAudio]);
    return <Audio autoPlay srcObject={audioStream} controls />;
  }, [streamTracks.combinedAudio]);

  return (
    <div className="current-meeting-status-bar-user">
      <div className={`meeting-controller-widget current-meeting-status-bar-list-users ${count > 4 && "more-users"}`}>
        {otherParticipantsData.map((user) => (
          <ParticipantCamera key={user.pid} participantData={user} videoStream={vStream} videoHeight={videoHeight} />
        ))}
        {renderAudio()}
      </div>
      <div className="current-meeting-status-bar-add-prople">
        <span className="icon-with-black-bg i-32" id="tooltip-a1">
          <img src={iAddPeople} className="i-16" alt="" />
          {!!(inRoomParticipants.length - 1) && <div className="badge black"> {inRoomParticipants.length} </div>}
        </span>
        <div className="fg-tooltip dark-mode top-center" id="tooltip-3">
          Add & Manage Participants
        </div>
      </div>
    </div>
  );
};

export default observer(CurrentMeetingUsersStatusBar);
